import { PipeTransform, Pipe } from '@angular/core';
import { AccountInfoModelList } from '@app/models/account-info/myAccountInfoModel';
import { CustomerDuePayment } from '@app/models/merchant/CustomerDuePayment';

@Pipe({
    name: 'customercardfilter'
})
export class CustomerFilterPipe implements PipeTransform {
    transform(customer: AccountInfoModelList[], searchTerm: string): AccountInfoModelList[] {
        if (!customer || !searchTerm) {
            return customer;
        }
        return customer.filter(customerSearch =>
            customerSearch.CardNumber.indexOf(searchTerm) !== -1);
    }
}


@Pipe({
    name: 'filter'
})
export class SearchFilterPipe implements PipeTransform {
    transform(items: CustomerDuePayment[], searchData: string): CustomerDuePayment[] {
        if (!items || !searchData) {
            return items;
        }
        return items.filter(item =>{
            if(item.Compare==1){
            if(item.CustomerCode.toLowerCase().indexOf(searchData.toLowerCase()) !== -1)
            {
                return true;
            }
        }
        if(item.Compare==2){
            if(item.MobileNumber.toLowerCase().indexOf(searchData.toLowerCase()) !== -1)
            {
                return true;
            }
        }
            return false;
        })
    
}
}


// WEBPACK FOOTER //
// ./src/app/pipes/customerCardfilter.pipe.ts